import { render, staticRenderFns } from "./NYTStrandsAccordionSection.vue?vue&type=template&id=49fa2a1f&scoped=true"
import script from "./NYTStrandsAccordionSection.vue?vue&type=script&lang=js"
export * from "./NYTStrandsAccordionSection.vue?vue&type=script&lang=js"
import style0 from "./NYTStrandsAccordionSection.vue?vue&type=style&index=0&id=49fa2a1f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49fa2a1f",
  null
  
)

export default component.exports